import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';
import { IMPERSONATION_NAMESPACE } from '../../common/constants/impersonation';
import { isImpersonationTab } from '../../services/impersonationSession';

const ReadOnlyAlert = ({ style }) => {
    const { t } = useTranslation([IMPERSONATION_NAMESPACE]);

    return <Alert type="warning" showIcon message={t('read-only.notice')} style={style} />;
};

// Explains disabled controls while impersonating; renders nothing (and loads no translations) otherwise.
export const ReadOnlyNotice = props => (isImpersonationTab() ? <ReadOnlyAlert {...props} /> : null);
